import Api from '@/services/Api'

export default {
    getAllRoles(){
        return Api().get('roles')
    },
    getAllRolesById(id){
        return Api().get('roles/getAllRolById/' + id)
    },
    updateRolById(infoRol){
        return Api().put('roles/update', infoRol)
    },
    createRol(infoRol){
        return Api().post('roles/create', infoRol)
    },
    inactivarRol(id){
        return Api().post('roles/inactivar/' + id)
    },
    activarRol(id){
        return Api().post('roles/activar/' + id)
    },
    getLimiteSesionesByRol(rolId){
        return Api().get('roles/getLimiteSesiones/' + rolId)
    },
    updateLimiteSesiones(info){
        return Api().put('roles/updateLimiteSesiones', info)
    }
}